import { render } from "./red-gradient-provider.svg?vue&type=template&id=cb8bd6ec"
const script = {}
script.render = render

export default script